export class AuthorizationError {
    message?: string;

    constructor(message?: string) {
        this.message = message;
    }
}
